import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as env } from 'src/environments/environment';
import { SearchResult, UserInfo, Customer, Roles } from '../../models';
import { QueryParamsModel } from 'src/app/shared/base/models';
import { delay, take } from 'rxjs/operators';

const API: any = {
  clients: 'customers',
  companies: 'companies',
  users: 'users',
  orders: 'orders',
  projects: 'projects',
  transfer: 'transfer',
};

@Injectable({ providedIn: 'root' })
export class SalesService {
  constructor(private readonly http: HttpClient) {}

  getClients(query: QueryParamsModel): Observable<SearchResult<Customer>> {
    return this.http
      .get<any>(env.apiUrl + API.clients + query.toUrlParams())
      .pipe((delay(1000), take(10)));
  }

  getCompanies(): Observable<any[]> {
    return this.http.get<any[]>(env.apiUrl + API.companies);
  }

  // Every CSR/CSM, including deactivated ones. Use this for filter dropdowns on list
  // screens, where you still need to filter historical records by someone who has left.
  getCsas(): Observable<any> {
    let params = new HttpParams();
    params = params.append('filter', `roleId==${Roles.CSA};${Roles.CSM}`);
    params = params.append('all', `true`);
    return this.http.get<UserInfo[]>(env.apiUrl + API.users, { params });
  }

  // Active CSR/CSM only. Use this wherever someone is being *assigned* — the server
  // rejects a deactivated user on save, so offering them just produces a confusing
  // "CSA with the ID 'N' was not found" at the end of the flow.
  getActiveCsas(): Observable<any> {
    let params = new HttpParams();
    params = params.append('filter', `roleId==${Roles.CSA};${Roles.CSM},isActive==true`);
    params = params.append('all', `true`);
    return this.http.get<UserInfo[]>(env.apiUrl + API.users, { params });
  }

  getCsasBySupervisor(): Observable<any> {
    return this.http.get<UserInfo[]>(env.apiUrl + API.users + '/csa-lookup-by-supervisor');
  }

  createClient(client: any): any {
    return this.http.post<any>(env.apiUrl + API.clients, client);
  }

  // TODO: Move to projectService
  postProject(projectDTO: any) {
    return this.http.post<any>(env.apiUrl + API.projects, projectDTO);
  }

  putCustomerTransferToCSR(customerId: number, request): Observable<any> {
    return this.http.put<any>(
      `${env.apiUrl}${API.clients}/${customerId}/${API.transfer}`,
      request
    );
  }

}
